<!-- 商品分类 -->

<template>
  <div class="pcOrder">
    <p style="margin-top: 10px; color: red" class="clearfix">
      <!-- <el-button style="float:right" type="primary" @click.stop="save">保存</el-button> -->
    </p>
    <div class="select-wrap" style="width: 100%">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
      </el-form>
    </div>
    <div class="goods-cont">
      <!-- <p class="tit" style="padding-bottom:10px;"><i></i>
          <el-button type="primary" @click.stop="save">保存</el-button>
        </p> -->
      <div class="goods-left">
        <div class="filter" style="">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="选择分类">
              <el-select v-model="typeId" placeholder="活动区域">
                <el-option key="" label="全部" value=""></el-option>
                <el-option
                  v-for="item in systemData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
                <el-option
                  v-for="item in typeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="warning" @click="getGoods">查询</el-button>
            </el-form-item>
          </el-form>
          <div style="display:flex;align-items: flex-start;">
            <el-button type="danger" class="upLoad" size="" @click="coverImg"
              ><input
                type="file"
                accept=".png,.jpg,.jpeg"
                @change="coverImg"
                class="pcImgFile"
                title="选择图片"
              />上传背景</el-button
            >
            <el-button
              type="primary"
              @click="openBigScreen"
              style="margin-left: 20px"
              >查看大屏</el-button
            >
            <el-button
              type="primary"
              @click="clearBg"
              style="margin-left: 20px"
              >恢复默认样式</el-button
            >
            <span class="txt-color" style="height:37px;">
              <el-radio-group v-model="isBold">
                <el-radio label="-1">默认字体</el-radio>
                <el-radio label="1">加粗字体</el-radio>
              </el-radio-group>
            </span>
            <span class="txt-color">选择字体颜色:<el-color-picker v-model="textColor"></el-color-picker></span>
            <el-button type="primary" @click="save">保存</el-button>
          </div>
        </div>

        <el-table
          ref="multipleTable"
          :data="tableData"
          :row-key="getRowKeys"
          @selection-change="handleSelectionChange"
          tooltip-effect="dark"
        >
          <!-- <el-table-column
            type="selection"
            width="65"
            :reserve-selection="true"
          ></el-table-column> -->
          <el-table-column label="商品名">
            <template slot-scope="scope">{{ scope.row.productName }}</template>
          </el-table-column>
          <el-table-column prop="typeName" label="分类"></el-table-column>
          <!--  -->
          <el-table-column label="参与排单">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.schedulingEnabled"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column label="参与制作">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.makeEnable"></el-checkbox>
            </template>
          </el-table-column>
          <!--  -->
          <el-table-column
            prop="price"
            label="价格"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            width="450"
            label="商品宣传语"
          >
              <template slot-scope="scope">
                <div class="form-item" style="display:flex;">
                    <el-input
                      type="text"
                      placeholder="请输入第一句描述"
                      v-model="scope.row.tips[0]"
                      :maxlength="12"
                      size="small"
                      show-word-limit
                    >
                    </el-input>
                    <el-input
                      style="margin:0 10px;"
                      type="text"
                      placeholder="请输入第二句描述"
                      v-model="scope.row.tips[1]"
                      :maxlength="12"
                      size="small"
                      show-word-limit
                    >
                  </el-input>
                  <el-button type="warning" size="small" @click.stop="saveTips(scope.row)">保存</el-button>
                </div> 
              </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <div class="goods-right">
        <p class="tit" style="padding-bottom:10px;">套餐选择
        </p>
        <el-table
          ref="multipleTableForMeals"
          :data="tableDataForMeals"
          :row-key="getRowKeys"
          @selection-change="handleSelectionChangeForMeal"
          tooltip-effect="dark"
        >
          <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
          <el-table-column label="商品名" width="240">
            <template slot-scope="scope">{{ scope.row.productName }}</template>
          </el-table-column>
          <el-table-column prop="typeName" label="分类" width="240"></el-table-column>
          <el-table-column prop="price" label="价格" show-overflow-tooltip></el-table-column>
        </el-table>
      </div> -->
    </div>
  </div>
</template>

<script type="text/javascript">
import { url } from "@/router/url.js";
import { BASE_URL ,API_BASE_URL} from "../../../urlConfig";
export default {
  name: "goodsBigScreen",
  props: ["curStoreId"],
  data() {
    return {
      isBold:"-1",
      makeBackUrl:{},
      textColor:"#333",
      allProductIds: [],
      typeId: "",
      systemData: [],
      typeList: [],
      tableDataForMeals: [],
      nowPage: 1,
      setMealIds: [],
      size: 1000,
      searchVal: "",
      curSelType: null,
      formInline: {
        user: "",
        region: "",
      },
      labelPosition: "right",
      newDiscount: {
        name: "",
        region: "",
        type: "",
        week: [],
        nowHours: "",
        tomorrowHour: "",
        discountMethod: "",
      },
      coverImgMaxSize: 15 * 1024 * 1024, // 图片最大字节数
      options: [],
      modifyDiscountItem: {},
      tableData: [],
      types: [],
      nowSelClassGoods: [],
      multipleSelection: [],
      multipleSelectionForMeal: [],
      totalPage: 0,
      totalElements: 0,
    };
  },
  methods: {
    clearBg(){
      this.$confirm('确认恢复默认背景?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.upDateImage("");
        this.textColor = "#333";
      })
    },
    //
    coverImg: function (e) {
      let reader = new FileReader();
      let that = this;
      let fileObj = e.target.files[0];

      if (e.target.files.length == 0) {
        return false;
      }

      // 判断图片大小
      if (fileObj.size > this.coverImgMaxSize) {
        this.errorMsg = "上传图片的大小不能超过15MB";
        this.openErrorTip = true;
        this.$message({
          message: "上传图片的大小不能超过15MB",
          customClass: "error",
        });
        return false;
      }

      reader.onload = (function (file) {
        return function (e) {
          let that2 = this; // 缓存当前this
          let img = new Image();
          img.src = this.result;
          img.onload = function () {
            let imgBase64 = that2.result; //获得图片的base64的数据
            that.mobileUploadImg(imgBase64);
          };
          $(".pcImgFile").val("");
        };
      })(e.target.files[0]);
      reader.readAsDataURL(e.target.files[0]);
    },
    mobileUploadImg: function (imgBase64) {
      const loading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$http
        .post(
          API_BASE_URL + "v1/image/json/upload?storeId=" + this.curStoreId,
          {
            file: imgBase64,
          }
        )
        .then((res) => {
          console.log(res.data.path)
          this.$message({ customClass: "success", message: "上传成功" });
          this.$nextTick(() => {
            let paramsInfo = JSON.stringify({
              bg:res.data.path,
              textColor:this.makeBackUrl.textColor,
              isBold:this.isBold,
            });
            this.upDateImage(paramsInfo);
          });
          loading.close();
        })
        .catch(() => {
          loading.close();
        });
    },
    upDateImage(makeBackUrl){
      this.$http({
        url:"update/back",
        method:"POST",
        data:{
          storeId:this.curStoreId,
          makeBackUrl
        }
      }).then(res=>{
        this.$message({
          message: "操作成功",
          customClass: "success",
        });
        this.getStoreInfo();
      })
    },
    // 
    openBigScreen() {
      window.open(this.bigScreenUrl, "_blank");
    },
    getRowKeys(row) {
      return row.productId;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(val);
    },
    handleSelectionChangeForMeal(val) {
      this.multipleSelectionForMeal = val;
      console.log(val);
    },
    // 新增优惠方式
    save() {
      let productIds = [];
      let schedulingEnabledProductIds = [];
      let notSchedulingEnabledProductIds = [];
      let notCatchGoodsIds = [];
      let setMealIds = [];
      // 
      if(this.tableData && Array.isArray(this.tableData)){
        this.tableData.forEach(it=>{
          if(it.makeEnable){
            productIds.push(it.productId);
          }
        })
      }
      // 
      if(this.tableData && Array.isArray(this.tableData)){
        this.tableData.forEach(it=>{
          if(it.schedulingEnabled){
            schedulingEnabledProductIds.push(it.productId);
          }
        })
      }
      // 
      // for (let j = 0; j < this.multipleSelection.length; j++) {
      //   productIds.push(this.multipleSelection[j].productId);
      // }
      for (let i = 0; i < this.multipleSelectionForMeal.length; i++) {
        setMealIds.push(this.multipleSelectionForMeal[i].productId);
      }
      // console.log("seled", this.multipleSelection);
      // let labels = [];
      // for (let i = 0; i < this.tableData.length; i++) {
      //   let obj = {
      //     labelEnabled:false,
      //     productId:this.tableData[i].productId
      //   }
      //   for(let j=0;j<this.multipleSelection.length;j++){
      //     if(this.multipleSelection[j].productId == this.tableData[i].productId){
      //       obj.labelEnabled = true;
      //     }
      //   }
      //   labels.push(obj);
      // }

      if (
        this.allProductIds &&
        Array.isArray(this.allProductIds) &&
        this.allProductIds.length
      ) {
        if (productIds && Array.isArray(productIds)) {
          this.allProductIds.forEach((it) => {
            if (productIds.indexOf(it) == -1) {
              notCatchGoodsIds.push(it);
            }
          });
        }
        // 
        if (schedulingEnabledProductIds && Array.isArray(schedulingEnabledProductIds)) {
          this.allProductIds.forEach((it) => {
            if (schedulingEnabledProductIds.indexOf(it) == -1) {
              notSchedulingEnabledProductIds.push(it);
            }
          });
        }
        // 
      }
      // 
      try {
        let paramsInfo = JSON.stringify({
          ...this.makeBackUrl,
          textColor:this.textColor,
          isBold:this.isBold,
        });
        console.log("paramsInfo",paramsInfo)
        console.log("makeBackUrl",this.makeBackUrl)
        this.upDateImage(paramsInfo);
      } catch (error) {
        console.log(error)
      }
      // 
      this.$http({
        url: "make",
        method: "POST",
        data: {
          productIds,
          makeEnabled: true,
          // storeId: this.curStoreId,
        },
      }).then((res) => {
        this.$message({
          message: "操作成功",
          customClass: "success",
        });
      });
      this.$http({
        url: "make",
        method: "POST",
        data: {
          productIds: notCatchGoodsIds,
          makeEnabled: false,
          // storeId: this.curStoreId,
        },
      }).then((res) => {});
      // 
      this.$http({
        url: "schedul",
        method: "POST",
        data: {
          productIds:schedulingEnabledProductIds,
          schedulingEnabled: true,
          // storeId: this.curStoreId,
        },
      }).then((res) => {
        // this.$message({
        //   message: "操作成功",
        //   customClass: "success",
        // });
      });
      this.$http({
        url: "schedul",
        method: "POST",
        data: {
          productIds: notSchedulingEnabledProductIds,
          schedulingEnabled: false,
          // storeId: this.curStoreId,
        },
      }).then((res) => {});
    },
    // 获取商品
    getGoods(page) {
      this.$http({
        url: "/products",
        method: "GET",
        params: {
          storeId: this.curStoreId,
          isStock: -1,
          kitchen: -1,
          typeId: this.typeId,
          // page,
          // size: this.size,
          // typeId:1,
        },
      }).then((res) => {
        let goodsList = res.data;
        let newGoodsData = [];
        if (
          !this.allProductIds ||
          !Array.isArray(this.allProductIds) ||
          !this.allProductIds.length
        ) {
          let allProductIds = [];
          for (let i = 0; i < goodsList.length; i++) {
            goodsList[i].count = 0;
            allProductIds.push(goodsList[i].id);
            goodsList[i].isChecked = goodsList[i].makeEnabled;
            
            if (goodsList[i].setMealEnabled) {
              goodsList[i].productId = goodsList[i].setMealId;
            }
          }
          this.allProductIds = allProductIds;
        }

        for (let j = 0; j < goodsList.length; j++) {
          let obj = {
            price: goodsList[j].salesPrice,
            productId: goodsList[j].id,
            productName: goodsList[j].name,
            setMealEnabled: goodsList[j].setMealEnabled,
            setMealId: goodsList[j].setMealId,
            typeId: goodsList[j].typeId,
            typeName: goodsList[j].typeName,
            isChecked: goodsList[j].isChecked,
            makeEnable: goodsList[j].isChecked,
            schedulingEnabled: goodsList[j].schedulingEnabled,
            tips:goodsList[j].tips ? goodsList[j].tips : ["",""],
          };
          newGoodsData.push(obj);
        }
        let arr = [];
        for (let i = 0; i < newGoodsData.length; i++) {
          if (newGoodsData[i].isChecked) {
            arr.push(newGoodsData[i]);
          }
        }
        arr.forEach((item) => {
          this.$refs.multipleTable.toggleRowSelection(item, true);
        });
        // this.goodsList = goodsList;
        this.tableData = newGoodsData;
        this.totalPage = res.data.totalPage;
        this.totalElements = res.data.totalElements;
        this.canChangePage = true;
        this.$forceUpdate();
      });
    },
    saveTips(row){
      console.log(row);
      if(row.tips && Array.isArray(row.tips) && row.tips.length){
        let flag = false;
        row.tips.forEach(it=>{
          if(String(it).length>12){
            flag = true;
          }
        });
        if(flag){
          this.$message({
            message: "商品描述限制在12字以内",
            customClass: "error",
          });
          return;
        }
      }
      if(row.productId){
        this.$http({
          url:"/make/tips",
          method:"POST",
          data:{
            productId:row.productId,
            tips:row.tips
          }
        }).then(res=>{
          this.$message({
            message: "操作成功",
            customClass: "success",
          });
        })
      }
    },
    getMeals(typeId) {
      return new Promise((resolve, reject) => {
        this.$http({
          url: "/meal/get-all-ps",
          method: "GET",
          params: {
            storeId: this.curStoreId,
            page: 0,
            size: this.size,
            typeId,
          },
        }).then((res) => {
          let goodsList = res.data.data;
          let newGoodsData = [];
          for (let i = 0; i < goodsList.length; i++) {
            goodsList[i].count = 0;
            goodsList[i].isChecked = goodsList[i].wechatEnabled;
            if (goodsList[i].setMealEnabled) {
              goodsList[i].productId = goodsList[i].setMealId;
            }
          }
          for (let j = 0; j < goodsList.length; j++) {
            let obj = {
              price: goodsList[j].price,
              productId: goodsList[j].productId,
              productName: goodsList[j].productName,
              setMealEnabled: goodsList[j].setMealEnabled,
              setMealId: goodsList[j].setMealId,
              typeId: goodsList[j].typeId,
              typeName: goodsList[j].typeName,
              isChecked: goodsList[j].isChecked,
              tips: goodsList[j].tips,
            };
            newGoodsData.push(obj);
          }
          resolve(newGoodsData);
          this.tableDataForMeals = newGoodsData;
        });
      });
    },
    getType() {
      this.$http({
        url: "product-types",
        method: "GET",
        params: {
          storeId: this.curStoreId,
        },
      }).then(async (res) => {
        let typeList = [];
        let systemData = [];
        if (res.data && res.data.data && Array.isArray(res.data.data)) {
          typeList = res.data.data;
        }
        if (
          res.data &&
          res.data.systemData &&
          Array.isArray(res.data.systemData)
        ) {
          systemData = res.data.systemData;
        }
        this.typeList = typeList;
        this.systemData = systemData;
        // let funArr = [];
        // for (let i = 0; i < res.data.length; i++) {
        //   if (res.data[i].setMealEnabled) {
        //     let fun = this.getMeals(res.data[i].id);
        //     funArr.push(fun);
        //   }
        // }
        // Promise.all(funArr)
        //   .then((res) => {
        //     console.log(res);
        //     let mealsArr = [];
        //     for (let i = 0; i < res.length; i++) {
        //       mealsArr = mealsArr.concat(res[i]);
        //     }
        //     console.log(mealsArr);

        //     let arr = [];
        //     for (let i = 0; i < mealsArr.length; i++) {
        //       if(mealsArr[i].isChecked){
        //         arr.push(mealsArr[i]);
        //       }
        //     }
        //     arr.forEach((item) => {
        //       this.$refs.multipleTableForMeals.toggleRowSelection(item, true);
        //     });

        //     this.tableDataForMeals = mealsArr;
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //   });
      });
    },
    getStoreInfo() {
      this.$http({
        url: `stores/${this.curStoreId}`,
        method: "GET",
      }).then((res) => {
        if(res.data.makeBackUrl && res.data.makeBackUrl.indexOf("{")!=-1){
          this.makeBackUrl = JSON.parse(res.data.makeBackUrl);
          if(this.makeBackUrl.hasOwnProperty("textColor") && this.makeBackUrl.textColor){
            this.textColor = this.makeBackUrl.textColor;
          }
          if(this.makeBackUrl.hasOwnProperty("isBold")){
            this.isBold = this.makeBackUrl.isBold;
          }else{
            this.isBold = "-1";
          }
        }else{
          this.makeBackUrl = {
            bg:res.data.makeBackUrl,
            textColor:"#333",
            isBold:"-1",//-1不加粗,1加粗
          }
          this.textColor = this.makeBackUrl.textColor;
          this.isBold = this.makeBackUrl.isBold;
        }
      });
    },
  },
  async mounted() {
    this.bigScreenUrl = `${window.location.origin}/#/sys/${this.curStoreId}/goodsBigScreen`;
    this.getGoods(0);
    this.getStoreInfo();
    await this.getType();
  },
};
</script>
<style lang="scss" scoped>
@import "./bigScreenGoods.scss";
.upLoad{
  position:relative;
}
.txt-color{
  display: flex;
  align-items: center;
  padding: 0 20px;
}
.pcImgFile {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// bigScreenGoods.vue?2023e446